import { Box } from '@mui/joy'
import { theme } from '@ui/style'
import setAds from '@utils/setAds'
import { useLayoutEffect } from 'react'

const WingRightAd = () => {
	useLayoutEffect(() => {
		setAds({
			id: '8MefP433S0yv4nl9rCiVvg',
			inventory: 'jtbc_p/article_news/article_news@article_wing_right_160x600?mlink=545',
		})
	}, [])
	return (
		<Box
			sx={{
				'@media all and (max-width: 1651px)': {
					display: 'none',
				},
			}}
			id="8MefP433S0yv4nl9rCiVvg_AD"
		/>
	)
}
export default WingRightAd
